module.exports = require("@swa-ui/core/src/Width/Width.module.scss");